import { render } from "./TableBodyRow.vue?vue&type=template&id=22f17dee&ts=true"
import script from "./TableBodyRow.vue?vue&type=script&lang=ts"
export * from "./TableBodyRow.vue?vue&type=script&lang=ts"

import "./TableBodyRow.vue?vue&type=style&index=0&id=22f17dee&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__